angular.module('impactx.orderprocess').directive('ixOrderProcessHeader', function ()
{
    return {
        scope: {
            sapData: "=",
            extraFields: "="
        },
        restrict: 'E',
        templateUrl: 'shared/orderprocess/templates/orderprocessheader.tmpl.html'
    };
});